import { render, staticRenderFns } from "./Virtual_service.vue?vue&type=template&id=89500af2"
import script from "./Virtual_service.vue?vue&type=script&lang=js"
export * from "./Virtual_service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports